var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"editor"},[(_vm.show)?_c('editor',{ref:"editor",attrs:{"api-key":"no-api-key","init":_vm.options},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }